import { createSlice } from "@reduxjs/toolkit";

export const ActiveTab = createSlice({
  name: "drawerTabs",
  initialState: {
    tabs: {
      catalogue: "category",
      client: "bussiness",
      notification: "notification",
      subscription: "invoice",
      admin_setting: "personal",
      sales: "summary",
      clientUsers: "clientList",
      clientCatalogue: "service",
      teams: "teamMemebrs",
      client_setting: "personal",
      marketPlace: "profiles",
      branch: "branch",
    },
  },
  reducers: {
    setActiveTab: (state, action) => {
      state.tabs = action.payload;
    },
  },
});

export const { setActiveTab } = ActiveTab.actions;

export default ActiveTab.reducer;
